<template>
  <div class="wrapper">
    <div class="section page-header lume-page-header" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-100 text-center">
            <h3 class="description lume-hero-eyebrow">
              {{ $t("lume.hero.eyebrow") }}
            </h3>
            <img class="lume-header-icon" :src="icon" />
            <h1 class="title-white">{{ $t("lume.header_title") }}</h1>
            <h4 class="subtitle lume-header-subtitle">
              {{ $t("lume.header_subtitle") }}
            </h4>
            <div class="lume-header-actions">
              <a
                class="lume-app-link"
                :href="appStoreUrl"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ $t("lume.app_store_cta") }}
              </a>
              <a class="lume-app-link lume-secondary-link" href="#overview">
                {{ $t("lume.hero.case_study_cta") }}
              </a>
            </div>
          </div>
        </div>
        <div v-if="isMobileDevice" class="md-layout margin-top-64">
          <div
            class="md-layout-item md-size-100 text-center"
            v-for="item in metaItems"
            :key="item.label"
          >
            <h4 class="subtitle">{{ item.label }}<br />{{ item.value }}</h4>
          </div>
        </div>
        <div v-else class="md-layout margin-top-64">
          <div class="md-layout" v-for="item in metaItems" :key="item.label">
            <div class="md-layout-item md-size-100 text-center">
              <h4 class="subtitle">{{ item.label }}<br />{{ item.value }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main">
      <div class="large-section">
        <div id="overview" class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h3 class="description">
                  {{ $t("lume.context.eyebrow") }}
                </h3>
                <h2 class="title text-left">
                  {{ $t("lume.context.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <h4 class="content text-left">
                  {{ $t("lume.context.description1") }}
                </h4>
                <h4 class="content text-left">
                  {{ $t("lume.context.description2") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <div class="lume-store-screens">
                  <div
                    class="lume-store-card"
                    v-for="screen in appScreenshots"
                    :key="screen.title"
                  >
                    <img :src="screen.image" :alt="screen.title" />
                    <p>{{ screen.title }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <div class="lume-product-question">
                  <h3 class="description">
                    {{ $t("lume.question.eyebrow") }}
                  </h3>
                  <h2 class="title text-left">
                    {{ $t("lume.question.title") }}
                  </h2>
                </div>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <h4 class="content text-left">
                  {{ $t("lume.question.description") }}
                </h4>
              </div>
            </div>
          </div>
        </div>

        <div class="section section-black">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-40 md-small-size-100">
                <h3 class="description">
                  {{ $t("lume.principles.eyebrow") }}
                </h3>
                <h2 class="title-white text-left">
                  {{ $t("lume.principles.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-60 md-small-size-100">
                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-50 md-small-size-100"
                    v-for="card in principleCards"
                    :key="card.title"
                  >
                    <div class="lume-dark-card">
                      <p class="lume-card-number">{{ card.number }}</p>
                      <h3>{{ card.title }}</h3>
                      <p>{{ card.body }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h3 class="description">
                  {{ $t("lume.flow.eyebrow") }}
                </h3>
                <h2 class="title text-left">
                  {{ $t("lume.flow.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <h4 class="content text-left">
                  {{ $t("lume.workflow.tone") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div
                class="md-layout-item md-size-20 md-small-size-100"
                v-for="step in flowSteps"
                :key="step.number"
              >
                <div class="lume-step-card">
                  <p>{{ step.number }}</p>
                  <h3>{{ step.title }}</h3>
                  <h4>{{ step.body }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section lume-soft-section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h3 class="description">
                  {{ $t("lume.sprites.eyebrow") }}
                </h3>
                <h2 class="title text-left">
                  {{ $t("lume.sprites.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-50 md-small-size-100"
                    v-for="sprite in spriteCards"
                    :key="sprite.name"
                  >
                    <div class="lume-spirit-card">
                      <div
                        class="lume-spirit-swatch"
                        :style="{
                          background: `linear-gradient(135deg, ${sprite.from}, ${sprite.to})`
                        }"
                      ></div>
                      <h3>{{ sprite.name }}</h3>
                      <p>{{ sprite.description }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <img class="fill-in-img lume-spirits-img" :src="spirits" />
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h3 class="description">
                  {{ $t("lume.workflow.eyebrow") }}
                </h3>
                <h2 class="title text-left">
                  {{ $t("lume.workflow.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <div
                  class="lume-workflow-row"
                  v-for="step in workflowSteps"
                  :key="step.number"
                >
                  <span>{{ step.number }}</span>
                  <h4 class="content text-left">{{ step.title }}</h4>
                </div>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <div class="lume-workflow-screens">
                  <div
                    class="lume-workflow-screen"
                    v-for="screen in workflowScreenCards"
                    :key="screen.title"
                  >
                    <img :src="screen.image" :alt="screen.title" />
                    <div class="lume-workflow-screen-copy">
                      <h3>{{ screen.title }}</h3>
                      <p>{{ screen.body }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section section-black">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h3 class="description">
                  {{ $t("lume.launch.eyebrow") }}
                </h3>
                <h2 class="title-white text-left">
                  {{ $t("lume.launch.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <div
                  class="lume-launch-row"
                  v-for="card in launchCards"
                  :key="card.title"
                >
                  <h3>{{ card.title }}</h3>
                  <p>{{ card.body }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h3 class="description">
                  {{ $t("lume.reflection.eyebrow") }}
                </h3>
                <h2 class="title text-left">
                  {{ $t("lume.reflection.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <h4 class="content text-left">
                  {{ $t("lume.reflection.description") }}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "lume",
  bodyClass: "lume-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/lume/hero.png")
    },
    icon: {
      type: String,
      default: require("@/assets/img/lume/icon.png")
    },
    spirits: {
      type: String,
      default: require("@/assets/img/lume/lounge_spirits_group.png")
    },
    appStoreIntro: {
      type: String,
      default: require("@/assets/img/lume/app_store_intro.jpg")
    },
    appStorePatterns: {
      type: String,
      default: require("@/assets/img/lume/app_store_patterns.jpg")
    },
    appStoreScore: {
      type: String,
      default: require("@/assets/img/lume/app_store_score.jpg")
    },
    appStoreTongue: {
      type: String,
      default: require("@/assets/img/lume/app_store_tongue.jpg")
    },
    appStoreSteps: {
      type: String,
      default: require("@/assets/img/lume/app_store_steps.jpg")
    },
    appStoreUrl: {
      type: String,
      default:
        "https://apps.apple.com/ca/app/lume-your-body-speaks/id6759819851"
    }
  },
  data() {
    return {
      isMobileDevice: this.$isMobile
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `linear-gradient(90deg, rgba(18, 18, 20, 0.72), rgba(18, 18, 20, 0.42), rgba(18, 18, 20, 0.62)), url(${this.header})`,
        backgroundPosition: "center 58%",
        backgroundSize: "cover"
      };
    },
    metaItems() {
      return [
        {
          label: this.$t("common.time"),
          value: this.$t("lume.meta.timeline")
        },
        {
          label: this.$t("common.role"),
          value: this.$t("lume.meta.role")
        },
        {
          label: this.$t("common.platform"),
          value: this.$t("lume.meta.platform")
        },
        {
          label: this.$t("lume.meta.scope_label"),
          value: this.$t("lume.meta.scope")
        }
      ];
    },
    appScreenshots() {
      return [
        {
          title: this.$t("lume.screens.scan"),
          image: this.appStoreTongue
        },
        {
          title: this.$t("lume.screens.score"),
          image: this.appStoreScore
        },
        {
          title: this.$t("lume.screens.patterns"),
          image: this.appStorePatterns
        },
        {
          title: this.$t("lume.screens.spirits"),
          image: this.appStoreSteps
        },
        {
          title: this.$t("lume.screens.menu"),
          image: this.appStoreIntro
        }
      ];
    },
    principleCards() {
      return [
        {
          number: "01",
          title: this.$t("lume.principles.card1.title"),
          body: this.$t("lume.principles.card1.body")
        },
        {
          number: "02",
          title: this.$t("lume.principles.card2.title"),
          body: this.$t("lume.principles.card2.body")
        },
        {
          number: "03",
          title: this.$t("lume.principles.card3.title"),
          body: this.$t("lume.principles.card3.body")
        },
        {
          number: "04",
          title: this.$t("lume.principles.card4.title"),
          body: this.$t("lume.principles.card4.body")
        }
      ];
    },
    flowSteps() {
      return [
        {
          number: "01",
          title: this.$t("lume.flow.step1.title"),
          body: this.$t("lume.flow.step1.body")
        },
        {
          number: "02",
          title: this.$t("lume.flow.step2.title"),
          body: this.$t("lume.flow.step2.body")
        },
        {
          number: "03",
          title: this.$t("lume.flow.step3.title"),
          body: this.$t("lume.flow.step3.body")
        },
        {
          number: "04",
          title: this.$t("lume.flow.step4.title"),
          body: this.$t("lume.flow.step4.body")
        },
        {
          number: "05",
          title: this.$t("lume.flow.step5.title"),
          body: this.$t("lume.flow.step5.body")
        }
      ];
    },
    spriteCards() {
      return [
        {
          name: this.$t("lume.sprites.qi.name"),
          description: this.$t("lume.sprites.qi.description"),
          from: "#ffe0b8",
          to: "#f7a66b"
        },
        {
          name: this.$t("lume.sprites.blood.name"),
          description: this.$t("lume.sprites.blood.description"),
          from: "#ffd1cf",
          to: "#df6d7c"
        },
        {
          name: this.$t("lume.sprites.yin.name"),
          description: this.$t("lume.sprites.yin.description"),
          from: "#dfe8ff",
          to: "#a99af7"
        },
        {
          name: this.$t("lume.sprites.yang.name"),
          description: this.$t("lume.sprites.yang.description"),
          from: "#ffeaa6",
          to: "#ff9e75"
        }
      ];
    },
    workflowSteps() {
      return [
        {
          number: "01",
          title: this.$t("lume.workflow.step1")
        },
        {
          number: "02",
          title: this.$t("lume.workflow.step2")
        },
        {
          number: "03",
          title: this.$t("lume.workflow.step3")
        },
        {
          number: "04",
          title: this.$t("lume.workflow.step4")
        }
      ];
    },
    workflowScreenCards() {
      return [
        {
          title: this.$t("lume.workflow.screens.card1.title"),
          body: this.$t("lume.workflow.screens.card1.body"),
          image: this.appStoreTongue
        },
        {
          title: this.$t("lume.workflow.screens.card2.title"),
          body: this.$t("lume.workflow.screens.card2.body"),
          image: this.appStoreScore
        },
        {
          title: this.$t("lume.workflow.screens.card3.title"),
          body: this.$t("lume.workflow.screens.card3.body"),
          image: this.appStorePatterns
        }
      ];
    },
    launchCards() {
      return [
        {
          title: this.$t("lume.launch.card1.title"),
          body: this.$t("lume.launch.card1.body")
        },
        {
          title: this.$t("lume.launch.card2.title"),
          body: this.$t("lume.launch.card2.body")
        },
        {
          title: this.$t("lume.launch.card3.title"),
          body: this.$t("lume.launch.card3.body")
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.lume-page-header {
  background-position: center;
}

.lume-hero-eyebrow {
  margin-bottom: 22px;
  color: rgba(255, 255, 255, 0.86);
}

.lume-header-icon {
  width: 88px;
  height: 88px;
  display: block;
  margin: 0 auto 28px;
  border-radius: 8px;
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.24);
}

.lume-header-subtitle {
  max-width: 760px;
  margin: 24px auto 0;
  color: rgba(255, 255, 255, 0.86) !important;
}

.lume-header-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-top: 32px;
}

.lume-app-link {
  display: inline-block;
  padding: 13px 22px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  color: white !important;
  font-weight: 600;
  text-decoration: none !important;
}

.lume-secondary-link {
  background: rgba(255, 255, 255, 0.12);
}

.lume-store-screens {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 18px;
  align-items: start;
}

.lume-store-card {
  padding: 10px 10px 14px;
  border: 1px solid rgba(23, 23, 23, 0.08);
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 18px 48px rgba(60, 64, 82, 0.1);

  &:nth-child(even) {
    margin-top: 38px;
  }

  img {
    width: 100%;
    display: block;
    border-radius: 8px;
  }

  p {
    margin: 12px 0 0;
    color: #5f6671;
    font-size: 0.82rem;
    font-weight: 700;
    line-height: 1.35;
    text-align: center;
  }
}

.lume-product-question {
  padding: 28px 0 0;
}

.lume-dark-card,
.lume-step-card,
.lume-spirit-card {
  min-height: 220px;
  margin-bottom: 24px;
  padding: 28px;
  border-radius: 8px;
}

.lume-dark-card {
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.07);

  h3 {
    margin: 18px 0 12px;
    color: white;
    font-size: 1.35rem;
    font-weight: 500;
  }

  p {
    color: rgba(255, 255, 255, 0.72);
    line-height: 1.75;
  }
}

.lume-card-number {
  margin: 0;
  color: rgba(255, 255, 255, 0.45) !important;
  font-weight: 700;
}

.lume-step-card,
.lume-spirit-card {
  border: 1px solid rgba(23, 23, 23, 0.08);
  background: white;
  box-shadow: 0 18px 48px rgba(60, 64, 82, 0.08);

  p {
    margin: 0;
    color: #9a9fa8;
    font-weight: 700;
  }

  h3 {
    margin: 24px 0 14px;
    color: #171717;
    font-size: 1.2rem;
    font-weight: 500;
  }

  h4 {
    margin: 0;
    color: #5f6671;
    font-size: 1rem;
    line-height: 1.7;
  }
}

.lume-soft-section {
  background: #f8f3ec;
}

.lume-spirit-card {
  min-height: 190px;
}

.lume-spirit-swatch {
  height: 82px;
  border-radius: 8px;
  margin-bottom: 18px;
}

.lume-spirits-img {
  max-width: 860px;
  display: block;
  margin: 0 auto;
}

.lume-workflow-row {
  display: grid;
  grid-template-columns: 54px minmax(0, 1fr);
  gap: 18px;
  align-items: start;
  padding: 18px 0;
  border-bottom: 1px solid rgba(23, 23, 23, 0.08);

  span {
    color: #9a9fa8;
    font-weight: 700;
  }

  h4 {
    margin: 0;
  }
}

.lume-workflow-screens {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
}

.lume-workflow-screen {
  overflow: hidden;
  border: 1px solid rgba(23, 23, 23, 0.08);
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 18px 48px rgba(60, 64, 82, 0.1);

  img {
    width: 100%;
    display: block;
  }
}

.lume-workflow-screen-copy {
  padding: 22px 20px 24px;

  h3 {
    margin: 0 0 10px;
    color: #171717;
    font-size: 1.15rem;
    font-weight: 600;
  }

  p {
    margin: 0;
    color: #5f6671;
    line-height: 1.65;
  }
}

.lume-launch-row {
  padding: 0 0 28px;
  margin-bottom: 28px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.16);

  h3 {
    margin: 0 0 10px;
    color: white;
    font-size: 1.28rem;
    font-weight: 500;
  }

  p {
    margin: 0;
    color: rgba(255, 255, 255, 0.72);
    font-size: 1rem;
    line-height: 1.75;
  }
}

@media (max-width: 960px) {
  .lume-store-screens {
    grid-template-columns: repeat(5, minmax(160px, 1fr));
    overflow-x: auto;
    padding-bottom: 16px;
  }

  .lume-store-card:nth-child(even) {
    margin-top: 0;
  }

  .lume-product-question {
    padding-top: 32px;
  }

  .lume-workflow-screens {
    grid-template-columns: 1fr;
  }
}
</style>
